export default "__VITE_ASSET__d81506bd__"